import { schema } from "normalizr";

// special unitListing schema without a unit relation to avoid circular dependency
export const unitListing = new schema.Entity("unitListing");
export const unit = new schema.Entity("unit", {
  unitListingCurrent: unitListing,
});
export const unitList = [unit];
